<template>
  <div class="app-container">
    <div class="header">
      <van-cell center title="仅显示我报名的交易会">
        <template #right-icon>
          <van-switch v-model="condition.reported" size="1rem" inactive-color="#dcdee0" @change="get_data" />
        </template>
      </van-cell>
    </div>
    <div class="card" v-if="loading.list">
      <van-loading class="ta-c" />
    </div>
    <div class="card-wrap" v-else>
      <div class="card" :key="fair.id" v-for="(fair, index) in tableData">
        <div class="title" v-text="fair.name"></div>
        <div class="brief">
          <div class="lines trade_date">
            <van-icon name="underway" /><span
              v-text="dayjs(`${fair.trade_date} ${fair.trade_time}`).format('YYYY-MM-DD HH:mm')"></span>
          </div>
          <div class="lines varietyname">
            <van-icon name="goods-collect" /><span v-text="fair.specials.map(s => s.varietyname).join()"></span>
          </div>
          <div class="lines signup_status">
            <van-icon name="info" /><span :class="{ reporting: signup_status(fair) === '报名中' }"
              v-text="signup_status(fair)"></span>
          </div>
          <van-button class="expand-btn" round plain type="info" :icon="fair.expand ? 'arrow-up' : 'arrow-down'"
            @click="toggle_expand(index)">
            <span v-text="fair.expand ? '隐藏详情' : '展开详情'"></span>
          </van-button>
        </div>
        <div class="details" v-if="fair.expand">
          <div class="detail" v-for="special in fair.specials" :key="special.id">
            <div class="lines subtitle" v-text="special.specialname">
            </div>
            <van-row class="lines">
              <van-col span="7"><span class="label">报名时间</span></van-col>
              <van-col span="17"> <span
                  v-text="`${dayjs(fair.signup_start_time).format('MM-DD HH:mm')}至${dayjs(fair.signup_end_time).format('MM-DD HH:mm')}`"></span></van-col>
            </van-row>
            <van-row class="lines">
              <van-col span="7"><span class="label">交易品种</span></van-col>
              <van-col span="17"> <span v-text="special.varietyname"></span></van-col>
            </van-row>
            <div v-for="apply in special.applies" :key="apply.id">
              <van-row class="lines">
                <van-col span="7"><span class="label">交易意向</span></van-col>
                <van-col span="17"> <span class="conspicuous" v-text="apply.amount"></span> 吨</van-col>
              </van-row>
              <van-row class="lines">
                <van-col span="7"><span class="label">保证金</span></van-col>
                <van-col span="17"> <span class="conspicuous" v-text="apply.totalmarginvalue"></span> 元</van-col>
              </van-row>
              <van-row class="lines">
                <van-col span="7"><span class="label">初审状态</span></van-col>
                <van-col span="17"> <span
                    :class="{ blue: apply.audit_status === '待审核', green: apply.audit_status === '通过', red: apply.audit_status === '不通过' }"
                    v-text="apply.audit_status"></span></van-col>
              </van-row>
              <van-row class="lines">
                <van-col span="7"><span class="label">保证金状态</span></van-col>
                <van-col span="17"> <span
                    :class="{ blue: apply.money_status === '待审核', green: apply.money_status === '审批通过' }"
                    v-text="apply.money_status"></span></van-col>
              </van-row>
              <van-button v-show="signup_status(fair) === '报名中' && ['待审核'].includes(apply.audit_status)" type="primary"
                plain class="full signup-btn" @click="special_apply(special)">修改报名</van-button>
            </div>
            <van-button v-if="signup_status(fair) === '报名中' && !special.applies.length" type="primary" plain
              class="full signup-btn" @click="special_apply(special)">报名此专场</van-button>
          </div>

        </div>
      </div>
    </div>
    <div class="card">
      <van-pagination class="pagination" v-model="page" :total-items="total" mode="simple" :items-per-page="limit"
        @change="get_data" />
    </div>
    <van-popup v-model="dialog.apply" style="width:90%" closeable @close="dialog_close">
      <h4 class="dialog-title" v-text="special.specialname"></h4>
      <van-form @submit="save">
        <van-field label="交易品种" input-align="right">
          <template #input>
            <span v-text="special.varietyname"></span>
          </template>
        </van-field>
        <van-field v-model="apply.amount" name="amount" label="交易意向" type="number" placeholder="请填写交易意向"
          :rules="[{ required: true }]" @blur="input_change(apply.amount)" :clearable="true" input-align="right">
          <template #button>
            <span>（吨）</span>
          </template>
        </van-field>
        <van-field label="交易保证金" disable input-align="right">
          <template #input>
            <span>{{ trademarginvalue }}（元）</span>
          </template>
        </van-field>
        <van-field label="履约保证金" disable input-align="right">
          <template #input>
            <span>{{ performmarginvalue }}（元）</span>
          </template>
        </van-field>
        <van-field label="合计保证金" disable input-align="right">
          <template #input>
            <span class="total">{{ (Number(trademarginvalue) + Number(performmarginvalue)).toFixed(2) }}（元）</span>
          </template>
        </van-field>
        <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit" :loading="loading.saving">提交</van-button>
        </div>
      </van-form>
    </van-popup>
  </div>
</template>

<script>
const clone = require('clone')
const dayjs = require('dayjs')
dayjs.extend(require('dayjs/plugin/isBetween'))
import { mapGetters } from "vuex"
export default {
  data() {
    return {
      dayjs,
      condition: {
        reported: false,
      },
      limit: 5,
      page: 1,
      total: 0,
      tableData: [],
      dialog: {
        apply: false,
      },
      loading: {
        list: false,
        saving: false
      },
      special: {},
      apply: {
        amount: null,
        trademarginvalue: 0,
        performmarginvalue: 0
      }
    };
  },
  computed: {
    ...mapGetters(["infos"]),
    trademarginvalue() {
      if (!this.special.btrademarginvalue) return 0
      if (!this.apply.amount) return 0
      if (!this.infos.coefficient) return 0
      return (this.special.btrademarginvalue * Number(this.apply.amount) * this.infos.coefficient).toFixed(2)
    },
    performmarginvalue() {
      if (!this.special.bperformmarginvalue) return 0
      if (!this.apply.amount) return 0
      if (!this.infos.coefficient) return 0
      return (this.special.bperformmarginvalue * Number(this.apply.amount) * this.infos.coefficient).toFixed(2)
    }

  },
  methods: {
    formatter(value) {
      if (Number(value) > Number(this.special.upper_limit)) {
        this.apply.amount = this.special.upper_limit
        return
      }
      this.apply.amount = Number(value).toFixed(3)
    },
    input_change(val) {
      if (Number(val) > Number(this.special.upper_limit)) {
        this.apply.amount = this.special.upper_limit
        return
      }
      this.apply.amount = Number(val).toFixed(3)
    },
    special_apply(special) {
      this.special = clone(special)
      const { applies } = this.special
      if (applies.length === 1) {
        const [apply] = applies
        Object.assign(this.apply, apply)
      }
      this.dialog.apply = true
    },
    dialog_close() {
      this.apply = {
        amount: null,
        trademarginvalue: 0,
        performmarginvalue: 0
      }
    },
    toggle_expand(index) {
      const special = this.tableData[index]
      special.expand = !special.expand
      this.tableData.splice(index, 1, special)
    },
    signup_status(fair) {
      const { signup_start_time, signup_end_time } = fair
      const d = dayjs();
      if (!(signup_start_time && signup_end_time)) return "-"
      if (d.isBefore(dayjs(signup_start_time))) return "报名未开始";
      if (d.isAfter(dayjs(signup_end_time))) return "报名已结束";
      return "报名中";
    },
    fair_status(fair) {
      const d = dayjs();
      const td = dayjs(`${fair.trade_date} ${fair.trade_time}`);
      if (!fair.publish) return "未发布";
      if (d.isBefore(td)) return "未开始";
      if (d.isAfter(td.endOf("day"))) return "已结束";
      if (d.isSame(rt, "day")) {
        if (d.isAfter(td)) {
          return "已开始"
        }
      }
    },
    get_data() {
      this.loading.list = true;
      this.$store
        .dispatch("fair/list", {
          page: this.page,
          limit: this.limit,
          condition: this.condition
        })
        .then((res) => {
          this.loading.list = false;
          this.total = res.count;
          this.tableData = res.rows;
          this.tableData.forEach(d => d.expand = false)
        })
        .catch(() => {
          this.loading.list = false;
        });
    },
    save() {
      const { apply, special } = this
      if (!apply.amount) {
        this.$toast({ type: 'warning', message: '请填写交易意向' })
        return
      }
      apply.platform = 'mobile'
      this.loading.saving = true
      this.$store
        .dispatch("apply/save", {
          apply,
          special
        })
        .then((res) => {
          this.$toast({ type: 'success', message: '操作成功' })
          this.dialog.apply = false
          this.get_data()
        })
        .finally((err) => (this.loading.saving = false));
    },
  },
  created() {
    this.get_data()
  }
};
</script>

<style lang="less" scoped>
@main-color: #1989fa;

.app-container {
  margin-top: -5%;
  padding: 0 5%;
  box-sizing: border-box;
}

.header {
  box-sizing: border-box;
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 5%;

  .van-cell {
    font-size: 0.8rem;
    padding: 5%;
  }

}

.card {
  padding: 5%;
  background: #fff;
  border-radius: 10px;
  box-shadow: rgba(#000, 0.1) 0 4px 5px;
  box-sizing: border-box;
  overflow: hidden;
  margin-bottom: 5%;
}



.title,
.subtitle {
  line-height: 1rem;
  font-size: 1rem;
  line-height: 1.5;
  margin-bottom: 3%;
  color: @main-color;
}

.lines {
  font-size: 0.8rem;
  margin-bottom: 3%;

  .van-icon {
    color: @main-color;
    margin-right: 2%;
  }
}

.row {
  margin: 1rem 0;
}

.brief {
  position: relative;
}

.expand-btn {
  position: absolute;
  right: 0;
  bottom: 0;
  word-break: keep-all;
  height: 2rem;
  font-size: 0.8rem;
}

.signup-btn {
  margin-top: 5%;
  border-radius: 10px;
}

.details {
  .detail {
    border-radius: 10px;
    margin-top: 3%;
    padding: 5%;
    background: #ebebfe;
  }
}

.conspicuous {
  color: #ff6816;
}

.reporting {
  color: #07c160
}

.dialog-title {
  margin: 4% 50px 4% 16px;
  line-height: 1.7;
}
</style>
